<template>
  <div>
    <v-timeline dense>
      <v-timeline-item small color="orangePcm" fill-dot>
        <v-card color="background">
          <div>
            <v-row dense>
              <v-col>
                <v-card-title>Ligação de Entrada</v-card-title>
              </v-col>
            </v-row>
            <v-row dense class="ml-4">
              <v-col align-self="center">
                <div>
                  <strong>Data/Hora: </strong>
                  {{ moment(dadosRelatorio.dateStartCall, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') }}
                </div>
              </v-col>
              <v-col align-self="center"> <strong>Origem: </strong> {{ dadosRelatorio.numeroOrigem }} </v-col>
              <v-col cols="3" align-self="center" v-if="dadosRelatorio.linkAudio && permissaoOuvirLigacao">
                <div class="groupEvent">
                  <div class="tituloEvent">Áudio:</div>
                  <div class="infoEvent">
                    <PlayerAudio
                      downloadable
                      :file="playerAudio(dadosRelatorio.linkAudio)"
                      :archive="dadosRelatorio.linkAudio"
                      color="primary"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider class="ma-2" />
            <v-row dense class="ml-4">
              <v-col cols="4" class="mb-4">
                <strong>Centro de Custo: </strong>
                {{ `${dadosRelatorio.centroDeCusto.codigo}-${dadosRelatorio.centroDeCusto.description}` }}
              </v-col>
              <v-col class="mb-4"> <strong>TC: </strong> {{ dadosRelatorio.tmc }} </v-col>
              <v-col class="mb-4"> <strong>TA: </strong> {{ dadosRelatorio.tma }} </v-col>
              <v-col class="mb-4"> <strong>TE: </strong> {{ dadosRelatorio.tme }} </v-col>
            </v-row>
          </div>
        </v-card>
      </v-timeline-item>
      <v-timeline-item
        :color="timelineColorMethod(key)"
        :fill-dot="fillDotMethod(key)"
        small
        v-show="dadosRelatorio.eventos.length > 0"
        v-for="(evento, key) in dadosRelatorio.eventos"
        :key="key"
      >
        <v-card color="background" v-show="key < dadosRelatorio.eventos.length - 1">
          <div>
            <v-row dense>
              <v-col>
                <v-card-title>Evento</v-card-title>
              </v-col>
            </v-row>
            <v-row no-gutters class="ml-4">
              <v-col align-self="center" class="my-4" cols="4">
                <div>
                  <strong>Data/Hora: </strong>
                  {{ moment(evento.dataHora, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') }}
                </div>
                <div class="mt-2" v-show="evento.ramalLogado !== ''"><strong>Operador: </strong> {{ evento.operador }}</div>
              </v-col>
              <v-col align-self="center" class="my-4 text-center" v-show="evento.tipo !== 'ABANDONADA' || evento.ramalLogado !== ''">
                <strong>Ramal: </strong> {{ evento.ramalLogado }}
              </v-col>
              <v-col align-self="center" class="my-4">
                <div :class="`infoEventCard ${colorVerify(evento.tipo)}--text text-center`">
                  {{ textModify(evento.tipo) }}
                </div>
              </v-col>
            </v-row>
            <v-row no-gutters class="ml-4 mt-n6">
              <v-col class="my-4"> </v-col>
            </v-row>
          </div>
        </v-card>
        <v-card color="background" v-show="key === dadosRelatorio.eventos.length - 1">
          <div>
            <v-row no-gutters>
              <v-col>
                <v-card-title>Evento Final</v-card-title>
              </v-col>
            </v-row>
            <v-row no-gutters class="ml-4">
              <v-col align-self="center" class="my-4" cols="4">
                <strong>Data/Hora: </strong>
                {{ moment(evento.dataHora, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') }}
              </v-col>
              <v-col align-self="center" class="my-4">
                <div class="text-center font-italic" v-if="evento.tipo !== 'TIME OUT'">
                  <strong>Desligado Por: </strong
                  >{{ evento.tipo === 'ABANDONADA' ? dadosRelatorio.numeroOrigem : evento.ramalLogado }}
                </div>
                <div class="text-center font-italic infoEventCard red--text" v-else>
                  TRANSBORDO
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import moment from 'moment'
// import SimpleCrypto from 'simple-crypto-js'

import { hostname } from '@/utils/hostname'

import PlayerAudio from './PlayerAudio'
export default {
  name: 'TimeLineEntrada',
  props: {
    dadosRelatorio: Object,
    permissaoOuvirLigacao: {
      type: Boolean,
      default: false,
    },
  },
  components: { PlayerAudio },
  data: () => ({
    moment: moment,
  }),

  methods: {
    playerAudio(audio) {
      return `https://${hostname()}/backend/asterisk/gravacao/fila/play/${audio}`
    },

    colorVerify(type) {
      if (type === 'ABANDONADA' || type === 'NÃO ATENDIDA' || type === 'ACESSO NEGADO' || type === 'ERRO') {
        return 'red'
      } else if (type === 'DESLIGADO PELO OPERADOR' || type === 'PENDENTE') {
        return 'orangePcm'
      } else if (type === 'ATENDIDA' || type === 'DESLIGADO PELA ORIGEM') {
        return 'green'
      } else if (type === 'TRANSFERENCIA') {
        return 'darkBlue'
      } else if (type === 'ENTROU NA FILA' || type === 'OUTROS') {
        return 'blue'
      }
    },

    textModify(type) {
      if (type === 'TRANSFERENCIA') {
        return 'TRANSFERÊNCIA'
      } else if (
        type === 'ATENDIDA' ||
        type === 'DESLIGADO PELO OPERADOR' ||
        type === 'DESLIGADO PELA ORIGEM' ||
        type === 'ABANDONADA' ||
        type === 'NÃO ATENDIDA'
      ) {
        return type
      } else if (type === 'TIME OUT') {
        return 'TRANSBORDO'
      } else {
        return 'ERRO'
      }
    },

    fillDotMethod(key) {
      if (key + 1 === this.dadosRelatorio.eventos.length) {
        return true
      } else {
        return false
      }
    },

    timelineColorMethod(key) {
      if (key + 1 === this.dadosRelatorio.eventos.length) {
        return 'orangePcm'
      } else {
        return 'bluePcm'
      }
    },
  },
}
</script>

<style scoped>
.groupEvent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.tituloEvent {
  font-size: 18px;
  padding-top: 3px;
  font-weight: bold;
  margin-bottom: 6px;
}
.infoEvent {
  font-size: 14px;
  margin-left: 8px;
}
.infoEventCard {
  font-size: 14px;
  margin: 4px;
  font-weight: bold;
}
</style>
